import { storageFactory } from './storageFactory'

export const local = storageFactory(() => localStorage)
export const sesstion = storageFactory(() => sessionStorage)
